import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IPersistentReminder, updatePersistentReminderList } from 'shared/persistent'
import { EventStatus } from 'types'

export const name = 'app'

interface intitialStateProps {
  reminderList: IPersistentReminder[]
  isLogin: boolean
  selectingEvent?: string
  currentEventStatus?: EventStatus
  // showLoading?: boolean
  autoRemindToBuy: boolean
  error?: { status: number; data: { code: number } }
}

const initialState: intitialStateProps = {
  reminderList: [],
  isLogin: true,
  selectingEvent: undefined,
  currentEventStatus: undefined,
  // showLoading: false,
  autoRemindToBuy: true,
  error: undefined,
}

const homeSlice = createSlice({
  name,
  initialState,
  reducers: {
    setReminderList: (state, action: PayloadAction<IPersistentReminder[]>) => {
      state.reminderList = action.payload
    },
    addReminder: (state, action: PayloadAction<IPersistentReminder>) => {
      state.reminderList = [...state.reminderList, action.payload]

      updatePersistentReminderList(state.reminderList)
    },
    setIsLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setSelectingEvent: (state, action) => {
      state.selectingEvent = action.payload
    },
    // setShowLoading: (state, action) => {
    //   state.showLoading = action.payload
    // },
    setCurrentEventStatus: (state, action: PayloadAction<EventStatus | undefined>) => {
      state.currentEventStatus = action.payload
    },
    setAutoRemindToBuy: (state, action: PayloadAction<boolean>) => {
      state.autoRemindToBuy = action.payload
    },
  },
})

export const {
  actions: {
    setReminderList,
    addReminder,
    setIsLogin,
    setError,
    setSelectingEvent,
    // setShowLoading,
    setCurrentEventStatus,
    setAutoRemindToBuy,
  },
} = homeSlice

export default homeSlice.reducer
